<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container">
            <div class="form-group" style="margin-top: 30px">

                <router-link :to="{path: '/issueType/create'}" class="btn btn-success">Add Issue Type</router-link>
<!--                <button type="button" class="btn btn-default" style="float: left"-->
<!--                        v-on:click="tableToExcel('testTable', 'W3C Example Table')" >{{ $t('Excel Output List') }}</button>-->

            </div>



            <div class="panel panel-default ">
                <div class="panel-heading"></div>
                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table   id="testTable"  class="table table-bordered table-striped table-hover">
                            <thead>
                            <tr>



                                <th>ردیف </th>
                                <th>عنوان  </th>

                                <th>نوع </th>
                                <th>وضعیت </th>
                                <th>فیلد ها </th>

                                <th width="100">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr id="items" v-for="(item, index) in items" :key="index">
                                <td>{{index+1 }}</td>

<!--                                <td > <span v-if="item.process">{{ item.process.title }}</span></td>-->

                                <td>{{ item.title }}</td>

                                <td>
                                    <span v-text="issueTypeText(item)"></span>
                                </td>
                                <td>{{ item.state}}</td>
                                <td>

                                    <CButton
                                            @click="manageFields(item.id)"
                                            color="secondary"
                                            class="btn-sm text-left"
                                    >
                                        مدیریت فیلدهای Issue Type
                                    </CButton>

                                </td>

                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->

                                <td>
                                    <router-link :to="{path: '/issueType/edit/'+item.id, params: {id: item.id}}"
                                                 class="btn btn-sm btn-default m-1 ">
                                        {{ $t('Edit') }}
                                    </router-link>
                                    <a href="javascript: void(0)" class="btn btn-sm btn-danger m-1 "
                                       v-on:click="deleteEntry(item.id, index)">
                                        حذف
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>
            <div class="col-xs-12 text-center">
                <pagination :api="`/api/issueTypes`" @pagnationChangeDate='pagnation'></pagination>

            </div>







            <b-modal :id="'field-manage-'+item.id" v-for="(item, modalIndex) in items" :key="'modal-'+modalIndex"   size="xl"
                 class="modal fade" role="dialog">

                    <!-- Modal content-->
                    <div class="">



                            <div class="modal-header ">
                                <h4 class="modal-title">Issue Type Fields  </h4>
                            </div>
                            <div class="modal-body">

                                <table class="table table-striped table-bordered table-sm">
                                    <thead>
                                    <tr>
                                        <th scope="col">
                                            <b-btn @click="addIssueTypeFields()" size="sm" variant="success">
                                                <i class="fa fa-plus"></i>
                                            </b-btn>
                                        </th>
                                        <th colspan="2">فیلد</th>
<!--                                        <th scope="col"></th>-->
                                        <th scope="col"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(issueTypeField , issueTypeFieldIndex) in issueTypeFields" :key="issueTypeFieldIndex">
                                        <th scope="row">{{issueTypeFieldIndex+1}}</th>
                                        <td colspan="2"  class="pt-0">
                                            <v-select
                                                    v-model="issueTypeField.field_id" class="form-control-sm"
                                                    :options="fields" label="title" :reduce="field => field.id" value="id">
                                            </v-select>
                                        </td>
<!--                                        <td :title="">-->
<!--                                            <input class="form-control form-control-sm" v-model="issueTypeField.price"-->
<!--                                                   type="number" data-type="number">-->
<!--                                        </td>-->

                                        <td>
                                        <span @click="deleteIssueTypeFields(issueTypeFieldIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>




                            </div>
                            <div class="modal-footer">
<!--                                <button type="button" class="btn btn-default"-->
<!--                                        data-dismiss="modal">{{ $t('Close') }}</button>-->
                                <button class="btn btn-primary" data-dismiss="modal"
                                        @click="updateIssueTypeFields(item.id)" >بروزرسانی فیلد ها</button>
                            </div>



                    </div>

            </b-modal>










        </div>
    </div>
</template>


<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                loader:false,





                fields:[],
                issueTypeFields:[],






            }
        },


        mounted() {
            this.loader=true
            axios
                .get(`/api/issueTypes`, this.auth)

                    .then(response => {
                    this.items = response.data.data;
                    console.log(this.items,"issueType");
                    this.loader=false

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning(rgis.$t('Your access to this section is restricted'));
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)


            this.getFields()
            // this.getIssueTypeFields()
        }


        ,
        methods: {


            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                if (number !== null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }

            },



            pagnation(api) {
                // console.log(api,"m")
                axios.get(api, this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.items = response.data.data;
                        //  console.log(response.data.data)
                        // this.pagnationDate = response.data
                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            deleteEntry(id, index) {
                if (confirm(this.$t('Are you sure you want to delete the item?'))) {
                    var app = this;
                    axios.delete(`/api/issueTypes/` + id, app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert(this.$t('Cannot delete item'));
                        });
                }
            },
            filteritem(item) {

                if (item == 1) {
                    return  this.$t('Active')
                } else {
                    return  this.$t('Inactive')
                }
            },

            filteritemType(item) {



                switch (item) {
                    case '1':
                        return  this.$t('In the process of payment')
                        break;
                    case '2':
                        return this.$t('pay')
                        break;
                    case '3':
                        return  this.$t('revoked')
                        break;
                    default:
                        return  this.$t('In the process of payment')
                }



            },




            getRelation(id) {
                // axios.get('/api/payment/CustomerPayment/' + id, this.auth)
                //     .then(function (resp) {
                //         console.log(resp.data.data.id);
                //         return resp.data.data.id;
                //     })
                //     .catch(function (resp) {
                //         return this.$t('Unknown') ;
                //     });
            },





            tableToExcel (table, name) {

                var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                if (!table.nodeType) table = document.getElementById(table)
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))

            },



            issueTypeText(issueType) {
                if (issueType.type == 1)
                    return 'سرنخ (Lead)'
                else if (issueType.type == 2)
                    return 'فرصت (Opportunity)'
                else if (issueType.type == 3)
                    return 'ملاقات/جلسه/رویداد'
                else if (issueType.type == 4)
                    return 'پیگیری (Ticket)'
                else if (issueType.type == 5)
                    return 'ایراد (Bug)'
                else if (issueType.type == 6)
                    return 'فعالیت (Task)'
                else if (issueType.type == 7)
                    return 'لیست/شرح (Story)'
                else if (issueType.type == 8)
                    return 'مجموعه/امکانات (Epic)'
                else if (issueType.type == 9)
                    return 'پیام/تلفن (Message)'
                else if (issueType.type == 10)
                    return 'گزارش/خبر (Report)'
                else if (issueType.type == 11)
                    return 'سایر'
                else
                    return 'سایر'
            },



























            manageFields(id){
                this.$bvModal.show('field-manage-'+id)
                this.issueTypeFields = []
                this.getIssueTypeFields(id)

            },

            getFields(){

                axios.get('/api/fieldList', this.auth)
                    .then(response => {
                        console.log(response.data);

                        this.fields = response.data;

                        // this.fields.forEach(function (element) {
                        //     element.number = "1";
                        // });
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false);

            },

            addIssueTypeFields(){

                this.issueTypeFields.push({
                    field_id: '',
                    // price: 0,
                    // initial_amount: 1,
                    // note:'',
                    state:1,

                });

            },

            deleteIssueTypeFields(key){

                this.issueTypeFields.splice(key,key);


            },

            getIssueTypeFields(id){

                let app = this;
                axios.get('/api/issueType/fields/'+ id, app.auth)
                    .then(response => {
                        console.log('issueTypeFields',response.data)
                        app.issueTypeFields = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })

            },

            updateIssueTypeFields(id){

                let app = this;

                let data =
                    {
                        issueTypeFields: app.issueTypeFields
                    }
                axios.post('/api/issueType/fields/'+ id, data , app.auth)
                    .then(response => {
                        app.$snotify.success(app.$t('Item saved successfully'));

                        app.getIssueTypeFields(id)
                    })
                    .catch(error => {
                        console.log(error);
                        app.$snotify.error('خطا در بروزرسانی فیلد ها');

                    })

            },









        },

















    }

</script>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
